module.exports = __webpack_public_path__ + "img/parent_top_background.35736a2c.jpg";